import 'bootstrap';
import * as $ from 'jquery';

const whiteLogo = require('../../img/white-logo.svg');
const Logo = require('../../img/logo.svg');
const OriginalLogo = require('../../img/logo.jpg');
const GreenLogo = require('../../img/conta-simples-logo.svg');
const pathname = window.location.pathname;

// if (
//   pathname === '/demo-dropshipping' ||
//   pathname === '/demo-dropshipping/'
// ) {
//   $(
//     '#main-navbar'
//   )[0].firstElementChild.firstElementChild.firstElementChild.src = Logo;
// }

if (
  pathname === '/calculadora-de-tarifas' ||
  pathname === '/calculadora-de-tarifas/'
) {
  $('#main-navbar').addClass('floating');
  $(
    '#main-navbar'
  )[0].firstElementChild.firstElementChild.firstElementChild.src = Logo;
} else {
  $(window).scroll(function () {
    if ($(window).scrollTop() >= 30) {
      $('#main-navbar').addClass('floating');

      // if (
      //   pathname === '/demo-dropshipping' ||
      //   pathname === '/demo-dropshipping/'
      // ) {
      //   $(
      //     '#main-navbar'
      //   )[0].firstElementChild.firstElementChild.firstElementChild.src = GreenLogo;
      // }

      if (
        pathname === '/empreendacast/' ||
        pathname === '/empreendacast' ||
        pathname === '/deepgrowth' ||
        pathname === '/deepgrowth/' ||
        pathname === '/likeaboss' ||
        pathname === '/likeaboss/'
      ) {
        $(
          '#main-navbar'
        )[0].firstElementChild.firstElementChild.firstElementChild.src = OriginalLogo;
      }
    } else {
      $('#main-navbar').removeClass('floating');

      // if (
      //   pathname === '/demo-dropshipping' ||
      //   pathname === '/demo-dropshipping/'
      // ) {
      //   $(
      //     '#main-navbar'
      //   )[0].firstElementChild.firstElementChild.firstElementChild.src = Logo;
      // }

      if (
        pathname === '/empreendacast/' ||
        pathname === '/empreendacast' ||
        pathname === '/deepgrowth' ||
        pathname === '/deepgrowth/' ||
        pathname === '/likeaboss' ||
        pathname === '/likeaboss/'
      ) {
        $(
          '#main-navbar'
        )[0].firstElementChild.firstElementChild.firstElementChild.src = whiteLogo;
      }
    }
  });
}

// const button = document.querySelector('.navbar-toggler');
// const navbar = document.querySelector('#main-navbar');
// let open = false;

// button.addEventListener('click', () => {
//   open = !open;

//   function preventDefault(e) {
//     e.preventDefault();
//   }

//   if (
//     pathname === '/demo-dropshipping' ||
//     pathname === '/demo-dropshipping/'
//   ) {
//     if (open) {
//       navbar.setAttribute(
//         'style',
//         'background-color: #ffffff !important'
//       );
//       document.body.setAttribute('style', 'overflow: hidden');

//       navbar.children[0].children[0].children[0].src = GreenLogo;
//     } else {
//       navbar.setAttribute('style', 'background-color: transparent');
//       navbar.children[0].children[0].children[0].src = Logo;
//       document.body.setAttribute('style', 'overflow: initial');
//     }
//   }
// });
